var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolldown"},[_c('span',{staticClass:"scrolldown_icon"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'angle-down']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }